/**
 * Copyright (C) 2017 Trend Micro Inc. All rights reserved.
 */
import { createStore as _createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './modules/reducer';
import { composeWithDevTools } from 'redux-devtools-extension';

export default function createStore(initialState) {
  let finalCreateStore;
  finalCreateStore = applyMiddleware(thunk)(_createStore);
  return finalCreateStore(reducer, initialState, composeWithDevTools());
}
